import { render, staticRenderFns } from "./Sleep.vue?vue&type=template&id=35634fca&scoped=true"
import script from "./Sleep.vue?vue&type=script&lang=js"
export * from "./Sleep.vue?vue&type=script&lang=js"
import style0 from "./Sleep.vue?vue&type=style&index=0&id=35634fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35634fca",
  null
  
)

export default component.exports